import { render, staticRenderFns } from "./IOSettings.vue?vue&type=template&id=c0069374&scoped=true"
import script from "./IOSettings.vue?vue&type=script&lang=js"
export * from "./IOSettings.vue?vue&type=script&lang=js"
import style0 from "./IOSettings.vue?vue&type=style&index=0&id=c0069374&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0069374",
  null
  
)

export default component.exports